
import React from "react";
import { BreadcrumbNavigation } from "@/components/ui/breadcrumb-list";

interface PageNavigationProps {
  breadcrumbItems: { label: string; href: string }[];
}

export function PageNavigation({ breadcrumbItems }: PageNavigationProps) {
  return (
    <div className="mb-6">
      <BreadcrumbNavigation items={breadcrumbItems} />
    </div>
  );
}
